import "../assets/css/styles.table.css"
import Layout from './Layout';
import {useDailyJournalHook} from '../hook/DailyJournalHook'
import Bindcomponent from '../utils/bindcomponent';
import React from "react";
import { Box } from "@mui/material";
const DailyJournal = () => {
    const {HandleSearch, AddDaiylyJournal,confirmStatusOpen, setConfirmStatusOpen, 
            roleAccess,setmessage,message,typeError, setTypeError,
            columns,data,roles,startDate,endDate,searchJournal,confirmEditOpen,setConfirmEditOpen,
            openPopupAndPrint,confirmDashboardOpen, setConfirmDashboardOpen, setRowToPrint,setFind,find} = useDailyJournalHook();

    return (
    <>
      <Layout message={message} setmessage={setmessage} tipe={typeError} settipe={setTypeError}>
        <div className='pd'><b>DAILY JOURNAL LIST</b></div>
     
        <div className="pd">
           
                <Box sx={{marginBottom:1, display:"flex", boxShadow:2, padding:1,paddingRight:1}}> 
                    <button className='btn btn-danger btn-sm' onClick={AddDaiylyJournal} disabled={!roleAccess.CREATE}>+ Daily Journal</button>
                    <div style={{position:"absolute", right:42}}>
                        {(roles.role  == "SUPERADMIN"  || roles.role == "PM") && (
                             <button className='btn btn-primary btn-sm mr-2' onClick={(e) => setConfirmDashboardOpen(true)} disabled={!roleAccess.READ}>Dashboard</button>
                        )}
                       
                        <button className='btn btn-warning btn-sm' onClick={openPopupAndPrint} disabled={!roleAccess.READ}>Export</button>
                    </div>
                </Box>
            <Box sx={{marginBottom:3,marginTop:2, boxShadow:2, paddingTop:1,paddingBottom:0.1,paddingLeft:1,paddingRight:1}}>
                <Bindcomponent component='StartEndDate' onClick={HandleSearch} ></Bindcomponent> 
                
            </Box>
            
            <Box sx={{height:"100%", boxShadow:2}}>
              <div style={{display:"flex",marginBottom:10,paddingTop:10,paddingLeft:5}}>
                                    <div style={{display:"flex",marginRight:30}}> 
                                        <span style={{marginRight:25,paddingTop:8,fontSize:12}}>Search</span>
                                         <input
                                            type="text"
                                            name="find"
                                             onChange={(e) => setFind(e.target.value)}
                                             value={find}
                                            placeholder="Enter the search."
                                            className='form-control'
                                            fullWidth
                                            required
                                          //  disabled={isLastId}
                                        /> 
                                    </div>
                                    
                  </div>
                 {/* <Bindcomponent component='GridNumberPaging' customcolumns={columns} rows={searchJournal} name={"dailyjournalgrid"} rowid={"id"}></Bindcomponent>   */}
                 <Bindcomponent component='GridCustomPaging' customcolumns={columns} rows={searchJournal} name={"dailyjournalgrid"} rowid={"id"} ></Bindcomponent>  
                     {/* <Bindcomponent component='DynamicDataGrid' customcolumns={columns} rows={searchJournal} name={"dailyjournalgrid"} rowid={"id"} ></Bindcomponent>   */}
                
            </Box>
        
        </div>
    
        <Bindcomponent component='Dialog' open={confirmStatusOpen} setOpen={setConfirmStatusOpen} maxWidth='sm' title={"CREATE DAILY JOURNAL"} subtitle={""} >
              <Bindcomponent component='DailyJournalAdd' customer={roles.userID} setmessage={setmessage} close={setConfirmStatusOpen} bind={async () => {
                    await HandleSearch(startDate,endDate); 
                  
                }} />   
           
        </Bindcomponent>
      
        <Bindcomponent component='Dialog' open={confirmEditOpen} setOpen={setConfirmEditOpen} maxWidth='sm' title={"EDIT DAILY JOURNAL"} subtitle={""} >
              <Bindcomponent component='DailyJournalEdit' data={data} setmessage={setmessage} close={setConfirmEditOpen} bind={async () => {
                    await HandleSearch(startDate,endDate); 
                  
                }} />   
          
        </Bindcomponent>
     
        <Bindcomponent component='Dialog' open={confirmDashboardOpen} setOpen={setConfirmDashboardOpen} maxWidth='md' title={"DAILY JOURNAL DASHBOARD"} subtitle={""} >
              <Bindcomponent component='DailyJournalDashboard' data={data} setmessage={setmessage} close={setConfirmDashboardOpen} bind={async () => {
                   
                }} />   
          
        </Bindcomponent>
      </Layout>
    </>
      );
    
}

export default React.memo(DailyJournal)